export function isWebAuthnSupported() {
  return typeof window.PublicKeyCredential !== 'undefined';
}

export function isSafari() {
  const userAgent = (navigator?.userAgent ?? '').toLowerCase();
  const isSafari = /version\/(\d+).+?safari/.test(userAgent);
  return isSafari;
}
